import { render, staticRenderFns } from "./page-action-row.vue?vue&type=template&id=3266c71a"
import script from "./page-action-row.vue?vue&type=script&lang=js"
export * from "./page-action-row.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports